<template>
  <div
    class="flex w-full flex-col md:w-[477px] lg:w-[614px] xl:w-[740px] 2xl:w-[860px]"
  >
    <TransitionGroup name="list">
      <LazyEventRow
        v-for="event in items"
        :key="event.id"
        :event="event"
        :is-archive="isArchive"
        :is-notice="isNotice"
      />
    </TransitionGroup>

    <ShowMoreButton
      v-if="hasMore"
      type="border"
      class="mt-7.5 xl:mt-10"
      button-color="dark"
      @click="emit('loadMore')"
    />
  </div>
</template>

<script setup lang="ts">
import type { AppEvent } from '~/types'

interface Props {
  items: AppEvent[]
  hasMore?: boolean
  loading?: boolean
  isArchive?: boolean
  isNotice?: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'loadMore'): void
}>()
</script>

<style scoped>
.list-enter-active,
.list-leave-active {
  transition: all 0.4s ease;
}
.list-enter-from {
  opacity: 0;
  transform: translateY(15px);
}
</style>
